import { HTTP } from "./../../helpers/http-common";
import { APIURLS } from "./../../helpers/apiUrls";
import axios from "axios";
import router from "./../../router";
import { LOGINRADIUSCONFIG  }from "./../../helpers/constants";

let REFRESHTOKEN_TIMEOUT;

// initial state
const state = () => ({
  loginError: null,
  signUpError: null,
  userProfile: null,
  access_token: null,
  healthCheckData: null,
  allNotificationData: null
  
});

// getters
const getters = {};

// actions
const actions = {
  loginAction({ commit, dispatch, state }, parms) {
    const loginUrl = `${LOGINRADIUSCONFIG.apidomain}/identity/v2/auth/login?ApiKey=${LOGINRADIUSCONFIG.apikey}`;
    const payLoad = {
      email: parms.email,
      password: parms.password,
      action: "loginByEmail",
    };
    return axios
      .post(loginUrl, payLoad)
      .then((response) => {
        //localStorage.setItem('access_token', response.data.access_token);
        // commit("setAccestoken", response.data.access_token )

        // sessionStorage.setItem("emailId", parms.email);
        sessionStorage.setItem("access_token", response.data.access_token);
        sessionStorage.setItem("refresh_token", response.data.refresh_token);
        const expiresInMilliseconds = new Date().valueOf() + ((LOGINRADIUSCONFIG.refreshTokenTimeInMinutes -1) * 60 * 1000);
        sessionStorage.setItem("expires_in",  + expiresInMilliseconds);
        if (response.data.Profile.CustomFields.AccessType === "Admin") {
          return dispatch("getBearerToken", response.data.access_token).then((res) => {
            dispatch("getProfileIdByEmail", parms);
          });
        }
        else{
          commit("setLoginError", 'Either the user ID and/or password is invalid or you do not have permissions to login');
        }
    
        // router.push("/");
      })
      .catch((error) => {
       commit("setLoginError", 'Either the user ID and/or password is invalid or you do not have permissions to login');
              });
  },

  
  getProfileIdByEmail({ dispatch, commit, state }, params) {
    // const emailId = sessionStorage.getItem("emailId");
    return HTTP.post(`${APIURLS.getProfileIdByEmail}`, { email: params.email })
      .then((response) => {
        sessionStorage.setItem(
          "userId",
          response.data.kitchenerUserProfile.userId
        );
        if (params.rememberMe) {
          params.password = "";
          localStorage.setItem("userInfo", JSON.stringify(params));
        }
       
        router.push("/admin");
        return response;
        // dispatch("getProfileData", response.data.kitchenerUserProfile.userId);
        // dispatch("getUserSettings", response.data.kitchenerUserProfile.userId);
        // dispatch("getUseraddresses", response.data.kitchenerUserProfile.userId);
      })
      .catch((error) => {
        commit('dashboard/setCustomToastData', {
          message: error.response.data,
          key: false,
          type: "danger",
        }, { root: true });
        return Promise.reject(error);
      });
  },
  getBearerToken({ commit }, accessToken) {
    return HTTP.get(`${APIURLS.getBearerToken}/${accessToken}`)
      .then((response) => {
        HTTP.defaults.headers.common['Authorization'] = `Bearer ${response.data}`;
        if (sessionStorage.getItem("bearerToken")) {
          sessionStorage.removeItem(
            "bearerToken"
          );
        }
      sessionStorage.setItem(
        "bearerToken",
        response.data
      );
      return response;
      })
      .catch((error) => {
        commit("setLoginError", 'Authentication failed');
        return Promise.reject(error);
      });
  },
  refreshToken({ commit, dispatch, state }) {
    if (REFRESHTOKEN_TIMEOUT) {
      clearTimeout(REFRESHTOKEN_TIMEOUT);
    }
    const REFRESHTOKEN = sessionStorage.getItem("refresh_token");
    const EXPIRESIN = sessionStorage.getItem("expires_in");
    if (EXPIRESIN) {
      const TIMEDIFF = Number(EXPIRESIN) - new Date().valueOf();
      REFRESHTOKEN_TIMEOUT = setTimeout(() => {
        const URL = `${APIURLS.getRefreshToken}/${REFRESHTOKEN}`;
        HTTP.get(URL)
          .then((response) => {
            sessionStorage.setItem("access_token", response.data.access_token);
            dispatch('getBearerToken', response.data.access_token);
            sessionStorage.setItem(
              "refresh_token",
              response.data.refresh_token
            );
            const expiresInMilliseconds =
              new Date().valueOf() +
              (LOGINRADIUSCONFIG.refreshTokenTimeInMinutes - 1) * 60 * 1000;
            sessionStorage.setItem("expires_in", expiresInMilliseconds);
            dispatch("refreshToken");
          })
          .catch((error) => { });
      }, TIMEDIFF);
    }
  },
  getInvalid_accesstoken({ dispatch, commit, state }, emailId) {
    // const emailId = sessionStorage.getItem("emailId");
    HTTP.get(`${APIURLS.getInvalid_accesstoken}${emailId}`).catch(
      (error) => {
      }
    );
  },
  getHealthCheckData({ commit, state }) {
    return HTTP.get(`${APIURLS.getHealthCheckData}`)
      .then((response) => {
        commit("setHealthCheckData", response.data);
        return response;
      })
      .catch((error) => {
        commit("setHealthCheckData", error.response);
        return Promise.reject(error);
      });
  },
  getAllNotificationData({ commit, state }) {
    return HTTP.get(`${APIURLS.getAllNotificationData}`)
      .then((response) => {
        commit("setAllNotificationData", response.data);
        return response;
      })
      .catch((error) => {
        commit("setAllNotificationData", error.response);
        return Promise.reject(error);
      });
  },


  loginErrorNull({ commit, state }, params) {
    commit("setLoginError", params);
  },
  logout({ commit }) {
    sessionStorage.clear();
    delete HTTP.defaults.headers.common["Authorization"];
    router.push("/").catch((err) => {});
    commit("setLoginError", null);
    commit("resetState");
  },
  
};

// mutations
const mutations = {
  resetState(state) {
    if (REFRESHTOKEN_TIMEOUT) {
      clearTimeout(REFRESHTOKEN_TIMEOUT);
    }
  },
  setLoginError(state, payload) {
    state.loginError = payload;
  },
  setUserProfile(state, payload) {
    state.userProfile = payload;
  },
  
  setAccestoken(state, payload) {
    state.access_token = payLoad;
  },
  setShowNotRegistered(state, payload) {
    state.showNotRegistered = payload;
  },
  setHealthCheckData(state, payload) {
    state.healthCheckData = payload;
  },
  setAllNotificationData(state, payload) {
    state.allNotificationData = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
